import React, { useState } from 'react';

const EMPTY = {
    ownerName: '',
    phone: '',
    dogName: '',
    dogAge: '',
    dogBreed: '',
    scheduledDate: '',
    notes: '',
};

export default function TrialBookingForm({ onSubmit, onCancel, loading, initialData }) {
    const [form, setForm] = useState(() => {
        if (initialData) {
            let dateStr = '';
            if (initialData.scheduledDate) {
                const d = new Date(initialData.scheduledDate);
                const y = d.getFullYear();
                const m = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                dateStr = `${y}-${m}-${day}`;
            }
            return {
                ...EMPTY,
                ...initialData,
                scheduledDate: dateStr
            };
        }
        return { ...EMPTY };
    });
    const [errors, setErrors] = useState({});

    const set = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const validate = () => {
        const e = {};
        if (!form.ownerName.trim()) e.ownerName = 'Nombre del dueño requerido';
        if (!form.dogName.trim()) e.dogName = 'Nombre del perro requerido';
        if (!form.scheduledDate) e.scheduledDate = 'Fecha requerida';
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        // Ensure we send a date that represents the selected day at local midnight
        // input type="date" gives "YYYY-MM-DD", which new Date() parses as UTC midnight.
        // We split and use the local Date constructor to avoid the timezone shift.
        const [year, month, day] = form.scheduledDate.split('-').map(Number);
        const localDate = new Date(year, month - 1, day);

        await onSubmit({
            ...form,
            scheduledDate: localDate.toISOString(),
        });
    };

    return (
        <form className="trial-form" onSubmit={handleSubmit}>
            <div className="trial-form-grid">
                <div className="trial-field">
                    <label>Nombre del dueño *</label>
                    <input name="ownerName" value={form.ownerName} onChange={set} placeholder="Ej. María García" />
                    {errors.ownerName && <span className="trial-error">{errors.ownerName}</span>}
                </div>
                <div className="trial-field">
                    <label>Teléfono de contacto</label>
                    <input name="phone" value={form.phone} onChange={set} type="tel" placeholder="Ej. 81 1234 5678" />
                </div>
                <div className="trial-field">
                    <label>Nombre del perro *</label>
                    <input name="dogName" value={form.dogName} onChange={set} placeholder="Ej. Luna" />
                    {errors.dogName && <span className="trial-error">{errors.dogName}</span>}
                </div>
                <div className="trial-field">
                    <label>Edad del perro</label>
                    <input name="dogAge" value={form.dogAge} onChange={set} placeholder="Ej. 2 años" />
                </div>
                <div className="trial-field">
                    <label>Raza</label>
                    <input name="dogBreed" value={form.dogBreed} onChange={set} placeholder="Ej. Golden Retriever" />
                </div>
                <div className="trial-field">
                    <label>Fecha del día de prueba *</label>
                    <input name="scheduledDate" value={form.scheduledDate} onChange={set} type="date" />
                    {errors.scheduledDate && <span className="trial-error">{errors.scheduledDate}</span>}
                </div>
                <div className="trial-field trial-field--full">
                    <label>Notas</label>
                    <textarea name="notes" value={form.notes} onChange={set} rows={3} placeholder="Alergias, comportamiento, instrucciones especiales…" />
                </div>
            </div>

            <div className="trial-form-actions">
                <button type="submit" className="trial-btn-primary" disabled={loading}>
                    {loading ? 'Guardando…' : '🎟️ Agendar día de prueba'}
                </button>
                <button type="button" className="trial-btn-secondary" onClick={onCancel}>
                    Cancelar
                </button>
            </div>
        </form>
    );
}
